import React from 'react'
import { withRouter } from 'react-router-dom'
import { PropTypes } from 'prop-types'
import { VisibilityFilters } from 'actions'
import MessageDisplay from 'components/MessageDisplay' // Toastr used to display Error messages only
import EmployerForm from './EmployerForm'
import Loading from 'components/Loading'
import api from '../../utils/api'

const Console = console

class Employer extends React.Component {
  constructor(props) {
    super(props)
    this.setDirty = this.setDirty.bind(this)
    this.submit = this.submit.bind(this)
    this.cancel = this.cancel.bind(this)
    this.showSuccessMessage = this.showSuccessMessage.bind(this)
    this.dismissSuccessMessage = this.dismissSuccessMessage.bind(this)
    this.state = {
      employer: null,
      errors: {},
      isDirty: this.props.isDirty,
      message: '',
      showSuccessMessage: false,
      isExternalUser: this.props.isExternalUser,
      hasLoadedData: false
    }
  }

  componentWillMount() {
    this.getData(this.props.match.params.employerId || 0)

    const employerId = this.props.match.params.employerId ? parseInt(this.props.match.params.employerId, 0) : 0

    if (this.props.contractorActiveFilter.employerId !== employerId) {
      this.props.setContractorActiveFilter({ employerId, filter: VisibilityFilters.SHOW_ACTIVE })
    }
  }

  getData(employerId) {
    const apiCall = () => (employerId === 0 ? api.getNewEmployer() : api.getEmployer(employerId))

    apiCall()
      .then(data => {
        this.setState({ employer: data, hasLoadedData: true })
      })
  }

  setDirty() {
    this.setState({ isDirty: true })
  }

  showSuccessMessage(message) {
    this.setState({ message, showSuccessMessage: true })
  }

  dismissSuccessMessage() {
    this.setState({ showSuccessMessage: false })
  }

  submit(payload) {
    const isNew = this.state.employer.id === 0
    const apiCall = isNew ? api.addEmployer : api.updateEmployer
    return apiCall({ ...this.state.employer, ...payload })
      .then((response) => {
        if (response.ok) {
          response.json().then((employer) => {
            if (isNew) {
              this.props.history.push(`/employers/${employer.id}#tab-colleagues`)
            } else {
              this.setState({ employer })
              this.setState({ errors: {} })
              this.setState({ isDirty: false })
              const message = 'Company details have been successfully updated'
              this.showSuccessMessage(message)
            }
          })
        } else {
          response.json().then((errors) => {
            this.setState({ errors })
            //Console.log(response.statusText)
          })
        }
      })
  }

  cancel() {
    this.props.history.push('/employers')
  }

  render() {
    return (
      <div>
        { this.state.hasLoadedData === false &&
        <div className="ln-o-grid">
          <div className="ln-o-grid__item ln-u-1/4">
            <Loading title="Loading Data" />
          </div>
        </div>
        }
        { this.state.hasLoadedData === true &&
        <div>
          <MessageDisplay ref={(messageComponent) => { this.messageDisplay = messageComponent }} />
          { this.state.isExternalUser ? <span>Not Found!</span> : this.state.employer != null &&
          <EmployerForm
            employer={this.state.employer}
            errors={this.state.errors}
            submit={this.submit}
            cancel={this.cancel}
            setDirty={this.setDirty}
            selectedTab="tabpanel-details"
            show={this.state.showSuccessMessage}
            message={this.state.message}
            onDismiss={this.dismissSuccessMessage}
          />
          }
        </div>
        }
      </div>
    )
  }
}

Employer.propTypes = {
  isDirty: PropTypes.bool.isRequired,
  match: PropTypes.shape({
    params: PropTypes.shape({
      employerId: PropTypes.string
    }).isRequired
  }).isRequired,
  history: PropTypes.shape({
    push: PropTypes.func.isRequired
  }).isRequired,
  contractorActiveFilter: PropTypes.shape({
    employerId: PropTypes.number.isRequired,
    filter: PropTypes.string.isRequired
  }).isRequired,
  setContractorActiveFilter: PropTypes.func.isRequired,
  isExternalUser: PropTypes.bool.isRequired
}

Employer.defaultProps = {
  isExternalUser: false
}

export default withRouter(Employer)



// WEBPACK FOOTER //
// ./src/components/Employer/Employer.jsx